import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseService} from "app/views/base.service";
import {UserProvider, UserRole} from "app/models/acl.model";
import { User } from '../models/support.model';
import { DataProvider2, DataProviderFactory, DataRequest } from "../provider/data2.provider";



@Injectable()
export class UserService extends BaseService {
	public reg_day: DataRequest;
	public activity: DataRequest;
	public userLive: DataRequest;
	public userCharts: DataRequest;
	
	constructor(
		public http: HttpClient,
		public dp: DataProvider2,
		public dpf: DataProviderFactory,
	) {
		super(http);
		
		this.reg_day = this.dpf.getNew('reg_day');
		this.activity = this.dpf.getNew('activity');
		this.userLive = this.dpf.getNew('user/live');
		this.userCharts = this.dpf.getNew('user_charts');
	}
	
	getProviderList(): Observable<UserProvider[]> {
		return this.dp.get('/user/provider');
	}
	
	addProvider(newProvider: UserProvider): Observable<UserProvider> {
		return this.dp.post('/user/provider', newProvider);
	}

	editProvider(provider: UserProvider): Observable<UserProvider> {
		return this.dp.put(`/user/provider/${provider._id}`, provider);
	}
	
	deleteProvider(provider: UserProvider) {
		return this.dp.delete(`/user/provider/${provider._id}`);
	}
	
	getRoleList(): Observable<UserRole[]> {
		return this.dp.get('/user/role');
	}
	
	addRole(newRole: UserRole): Observable<UserRole> {
		return this.dp.post('/user/role', newRole);
	}
	
	editRole(role: UserRole): Observable<UserRole> {
		return this.dp.put(`/user/role/${role._id}`, role);
	}
	
	deleteRole(role: UserRole): Observable<any> {
		return this.dp.delete(`/user/role/${role._id}`);
	}
}
